import { makeActionCreator } from '../../config/store/utils'
import { getBuyersSize } from '../../services/buyers'

export const GET_PROVIDERS_NUMBER = 'GET_PROVIDERS_NUMBER'
export const GET_PROVIDERS_NUMBER_ERROR = 'GET_PROVIDERS_NUMBER_ERROR'
export const GET_PROVIDERS_NUMBER_SUCCESS = 'GET_PROVIDERS_NUMBER_SUCCESS'
export const onGetProvidersNumber = makeActionCreator(GET_PROVIDERS_NUMBER)
export const onGetProvidersNumberError = makeActionCreator(GET_PROVIDERS_NUMBER_ERROR, 'payload')
export const onGetProvidersNumberSuccess = makeActionCreator(GET_PROVIDERS_NUMBER_SUCCESS, 'payload')
export const onGetProvidersNumberThunk = payload => async dispatch => {
  dispatch(onGetProvidersNumber())

  try {
    const { data } = await getBuyersSize({ sectorId: 7, year: payload.year })
    const enhancedData = data.payload.map(item => ({
      amount: item.amountCLP,
      amountUSD: item.amountUSD,
      name: item.size,
      sector: item.sector,
      percentage: item.percentageCLP
    }))
    const csv = [
      ['Año', 'Proveedor', 'RUT proveedor', 'Monto transado', 'Monto transado (USD)'],
      ...enhancedData.map(item => [payload.year, item.name, item.sector, item.amount, item.amountUSD])
    ]

    return dispatch(onGetProvidersNumberSuccess({ csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetProvidersNumberError({ error }))
  }
}

export const GET_PROVIDERS_PURCHASING_MECHANISM = 'GET_PROVIDERS_PURCHASING_MECHANISM'
export const GET_PROVIDERS_PURCHASING_MECHANISM_ERROR = 'GET_PROVIDERS_PURCHASING_MECHANISM_ERROR'
export const GET_PROVIDERS_PURCHASING_MECHANISM_SUCCESS = 'GET_PROVIDERS_PURCHASING_MECHANISM_SUCCESS'
export const onGetProvidersPurchasingMechanism = makeActionCreator(GET_PROVIDERS_PURCHASING_MECHANISM)
export const onGetProvidersPurchasingMechanismError = makeActionCreator(
  GET_PROVIDERS_PURCHASING_MECHANISM_ERROR,
  'payload'
)
export const onGetProvidersPurchasingMechanismSuccess = makeActionCreator(
  GET_PROVIDERS_PURCHASING_MECHANISM_SUCCESS,
  'payload'
)
export const onGetProvidersPurchasingMechanismThunk = payload => async dispatch => {
  dispatch(onGetProvidersPurchasingMechanism())

  try {
    const { data } = await getBuyersSize({ sectorId: 7, year: payload.year })
    const enhancedData = data.payload.map(item => ({
      amount: item.amountCLP,
      amountUSD: item.amountUSD,
      name: item.size,
      sector: item.sector,
      percentage: item.percentageCLP
    }))
    const csv = [
      ['Año', 'Proveedor', 'RUT proveedor', 'Monto transado', 'Monto transado (USD)'],
      ...enhancedData.map(item => [payload.year, item.name, item.sector, item.amount, item.amountUSD])
    ]

    return dispatch(onGetProvidersPurchasingMechanismSuccess({ csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetProvidersPurchasingMechanismError({ error }))
  }
}
